import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { StorageService } from '@core/services';
import { DOCUMENT, inject } from '@angular/core';
import { map } from 'rxjs';

export const redirect: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const storageSvc = inject(StorageService);
  const router = inject(Router);
  const document = inject(DOCUMENT);
  const fullRoute = segments.map(({ path }) => path).join('/');

  return storageSvc.currentUser$.pipe(
    map(user => {
      if (!user) {
        const window = document.defaultView;
        if (fullRoute) {
          window?.sessionStorage.setItem('_returnRoute', `${window.location.origin}/${fullRoute}`);
        }
        router.navigate(['/login']);
      } else {
        const navigationExtras = sessionStorage.getItem('_returnRoute')?.split(window.location.origin).at(1)
          ? {
              state: {
                viaCanMatch: true,
                type: 'redirect'
              }
            }
          : undefined;
        router.navigate([sessionStorage.getItem('routeHome')], navigationExtras);
      }
      return true;
    })
  );
};
